<template>
  <div class="nr-icon" :class="{ spinner: isSpinner }">
    <Component :is="dynamicIcon" />
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import { getIcon } from './iconRegistry'
import { IconName, IconType, isValidIconName } from './types'

export default {
  name: 'NrIcon',
  props: {
    name: {
      type: String as PropType<IconName>,
      required: true,
      validator: isValidIconName
    },
    iconType: {
      type: String as PropType<IconType>,
      default: 'regular',
      validator: (value: string): boolean => {
        const isValid = value === 'regular' || value === 'solid'
        if (!isValid) {
          console.warn(
            `Invalid icon type: "${value}". Must be either "regular" or "solid"`
          )
        }
        return isValid
      }
    }
  },
  computed: {
    validatedName(): IconName {
      return isValidIconName(this.name) ? this.name : 'archive'
    },
    isSpinner(): boolean {
      return this.validatedName === 'spinner'
    },
    dynamicIcon() {
      return getIcon(this.validatedName, this.iconType)
    }
  }
}
</script>

<style lang="scss">
.nr-icon {
  font-size: 1em;
  width: 1em;
  line-height: 1em;

  &.spinner {
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
